var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "fill", attrs: { "title-color": "primary" } },
        [
          _c("div", [
            _c("div", { staticClass: "row fill" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-4 shadow bg-white rounded overflow-y-scroll tree-panel"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Object.keys(_vm.getRepositories).length,
                          expression: "Object.keys(getRepositories).length"
                        }
                      ],
                      staticClass: "w-100"
                    },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            "enter-active-class": "animated fadeIn",
                            "leave-active-class": "animated fadeOut"
                          }
                        },
                        _vm._l(_vm.getRepositories, function(repository) {
                          return _c("RepositoriesTree", {
                            key: repository.repositorioId,
                            staticClass: "item",
                            attrs: { repository: repository }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.getRepositories.length <= 0
                    ? _c("span", [
                        _vm._v("No tienes acceso a ningun repositorio.")
                      ])
                    : _vm._e()
                ]
              ),
              _c(
                "div",
                { staticClass: "col-md-8", attrs: { id: "main-panel" } },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.loading } },
                    [
                      _c("MinimalNavigationPanel", {
                        attrs: {
                          "add-file": _vm.addFile,
                          toggle: _vm.toggle,
                          files: _vm.files,
                          "show-principal-button": _vm.showPrincipalButton,
                          "max-files": _vm.maxFiles
                        }
                      }),
                      _c("vs-divider"),
                      _c("h4", { staticClass: "text-primary" }, [
                        _vm._v("Documentos seleccionados")
                      ]),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.files, function(file) {
                          return _c(
                            "div",
                            { key: file.id, staticClass: "col-3 mt-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column align-items-center"
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: {
                                      icon: "description",
                                      size: "25px",
                                      color: "primary"
                                    }
                                  }),
                                  _c(
                                    "b",
                                    {
                                      staticClass:
                                        "text-truncate w-100 text-center"
                                    },
                                    [_vm._v(_vm._s(file.name))]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }